import { i18n, DataType } from '@easydata/core';
import { GridColumnAlign } from './easy_grid_columns';
var cssPrefix = "keg";
export var DFMT_REGEX = /{0:(.*?)}/g;
export var CellRendererType;
(function (CellRendererType) {
    CellRendererType[CellRendererType["STRING"] = 1] = "STRING";
    CellRendererType[CellRendererType["NUMBER"] = 2] = "NUMBER";
    CellRendererType[CellRendererType["DATETIME"] = 3] = "DATETIME";
    CellRendererType[CellRendererType["BOOL"] = 4] = "BOOL";
})(CellRendererType || (CellRendererType = {}));
var StringCellRendererDefault = function (value, column, cellValueElement, rowElement) {
    var text = value ? value.toString().replace(/\n/g, '\u21B5 ') : '';
    cellValueElement.innerText = text;
    cellValueElement.title = text;
    if (column.align == GridColumnAlign.NONE) {
        cellValueElement.classList.add(cssPrefix + "-cell-value-align-left");
    }
};
var NumberCellRendererDefault = function (value, column, cellValueElement, rowElement) {
    var strValue = (value || '').toString();
    if (typeof value == 'number') {
        if (column.dataColumn && column.dataColumn.displayFormat
            && DFMT_REGEX.test(column.dataColumn.displayFormat)) {
            strValue = column.dataColumn.displayFormat.replace(DFMT_REGEX, function (_, $1) {
                return i18n.numberToStr(value, $1);
            });
        }
        else {
            strValue = value.toLocaleString();
        }
    }
    cellValueElement.innerText = strValue;
    cellValueElement.title = strValue;
    if (column.align == GridColumnAlign.NONE) {
        cellValueElement.classList.add(cssPrefix + "-cell-value-align-right");
    }
};
var DateTimeCellRendererDefault = function (value, column, cellValueElement, rowElement) {
    var isDate = Object.prototype.toString.call(value) === '[object Date]';
    var strValue = (value || '').toString();
    if (isDate) {
        if (column.dataColumn && column.dataColumn.displayFormat
            && DFMT_REGEX.test(column.dataColumn.displayFormat)) {
            strValue = column.dataColumn.displayFormat.replace(DFMT_REGEX, function (_, $1) {
                return i18n.dateTimeToStr(value, column.type, $1);
            });
        }
        else {
            var locale = i18n.getCurrentLocale();
            var timeOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
            switch (column.type) {
                case DataType.Date:
                    strValue = value.toLocaleDateString(locale);
                    break;
                case DataType.Time:
                    strValue = value.toLocaleTimeString(locale, timeOptions);
                    break;
                case DataType.DateTime:
                    strValue = value.toLocaleDateString(locale) + " " + value.toLocaleTimeString(locale, timeOptions);
                    break;
            }
        }
    }
    cellValueElement.innerText = strValue;
    cellValueElement.title = strValue;
    if (column.align == GridColumnAlign.NONE) {
        cellValueElement.classList.add(cssPrefix + "-cell-value-align-right");
    }
};
var BoolCellRendererDefault = function (value, column, cellValueElement, rowElement) {
    if (column.dataColumn && column.dataColumn.displayFormat
        && DFMT_REGEX.test(column.dataColumn.displayFormat)) {
        var strValue = column.dataColumn.displayFormat.replace(DFMT_REGEX, function (_, $1) {
            return i18n.booleanToStr(value, $1);
        });
        return StringCellRendererDefault(strValue, column, cellValueElement, rowElement);
    }
    else {
        cellValueElement.classList.add(cssPrefix + "-cell-value-bool");
        cellValueElement.classList.add(cssPrefix + "-" + (value ? 'cell-value-true' : 'cell-value-false'));
    }
};
var GridCellRendererStore = /** @class */ (function () {
    function GridCellRendererStore(options) {
        this.renderers = {};
        this.defaultRenderers = {};
        this.registerRenderer('StringDefault', StringCellRendererDefault);
        this.setDefaultRenderer(CellRendererType.STRING, StringCellRendererDefault);
        this.registerRenderer('NumberDefault', NumberCellRendererDefault);
        this.setDefaultRenderer(CellRendererType.NUMBER, NumberCellRendererDefault);
        this.registerRenderer('DateTimeDefault', DateTimeCellRendererDefault);
        this.setDefaultRenderer(CellRendererType.DATETIME, DateTimeCellRendererDefault);
        this.registerRenderer('BoolDefault', BoolCellRendererDefault);
        this.setDefaultRenderer(CellRendererType.BOOL, BoolCellRendererDefault);
    }
    GridCellRendererStore.prototype.getDefaultRenderer = function (columnType) {
        var cellType = this.getCellType(columnType);
        return this.defaultRenderers[CellRendererType[cellType]];
    };
    GridCellRendererStore.prototype.getDefaultRendererByType = function (rendererType) {
        return this.defaultRenderers[CellRendererType[rendererType]];
    };
    GridCellRendererStore.prototype.setDefaultRenderer = function (cellType, renderer) {
        if (renderer) {
            this.defaultRenderers[CellRendererType[cellType]] = renderer;
        }
    };
    GridCellRendererStore.prototype.getRenderer = function (name) {
        return this.renderers[name];
    };
    GridCellRendererStore.prototype.registerRenderer = function (name, renderer) {
        this.renderers[name] = renderer;
    };
    GridCellRendererStore.prototype.getCellType = function (dataType) {
        switch (dataType) {
            case DataType.Autoinc:
            case DataType.Byte:
            case DataType.Word:
            case DataType.Currency:
            case DataType.Float:
            case DataType.Int32:
            case DataType.Int64:
                return CellRendererType.NUMBER;
            case DataType.Date:
            case DataType.DateTime:
            case DataType.Time:
                return CellRendererType.DATETIME;
            case DataType.Bool:
                return CellRendererType.BOOL;
            default:
                return CellRendererType.STRING;
        }
    };
    return GridCellRendererStore;
}());
export { GridCellRendererStore };
//# sourceMappingURL=easy_grid_cell_renderer.js.map